const EXTERNAL_DOMAINS = [
  'cdn0.employers.io',
  'cdn.employers.io',
  'cms.employers.io',
  'd1sp9gjgoi56ei.cloudfront.net'
]
function shouldProxyImage(url: string): boolean {
  if (!url || url.startsWith('/')) return false
  try {
    const urlObj = new URL(url)
    return EXTERNAL_DOMAINS.some(domain => urlObj.hostname.includes(domain))
  } catch {
    return false
  }
}
export function proxyImageUrl(imageUrl: string | null | undefined): string {
  if (!imageUrl) return ''
  if (imageUrl.startsWith('/') || imageUrl.startsWith('data:')) {
    return imageUrl
  }
  if (shouldProxyImage(imageUrl)) {
    return `/api/proxy/image?url=${encodeURIComponent(imageUrl)}`
  }
  return imageUrl
}
export function proxyImageUrls(urls: (string | null | undefined)[]): string[] {
  return urls.map(url => proxyImageUrl(url))
}
